import Axios from '../Axios';

const GroupOfMeter = {
	create(data) {
		return Axios.post('/groups_of_meters', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/groups_of_meters?&limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/groups_of_meters/' + id);
	},
	update(id, data) {
		return Axios.put('/groups_of_meters/' + id, data);
	},
	delete(id) {
		return Axios.delete('/groups_of_meters/' + id);
	},
};

export default GroupOfMeter;
